import secureApi from "../services/secureApi";

export const getBlogs = async () => {
  try {
    const response = await secureApi.get("/admin/blog-category/list");
    return response.data;
  } catch (error) {
    console.error("Error fetching blog categories:", error);
    throw error;
  }
};

export const getBlogById = async (slug) => {
  try {
    const response = await secureApi.get(
      `/admin/blog-category/view/${slug}`
    );

    console.log("Blog Category API:", response.data);

    return response.data;
  } catch (error) {
    console.error("Error fetching blog category:", error);
    throw error;
  }
};

export const createBlog = async (data) => {
  try {
    const response = await secureApi.post(
      "/admin/blog-category/add",
      data
    );

    return response.data;
  } catch (error) {
    console.error("Error creating blog category:", error);
    throw error;
  }
};

export const updateBlog = async (id, data) => {
  try {
    const response = await secureApi.put(
      `/admin/blog-category/edit/${id}`,
      data
    );

    return response.data;
  } catch (error) {
    console.error("Error updating blog category:", error);
    throw error;
  }
};

export const deleteBlog = async (id) => {
  try {
    const response = await secureApi.delete(
      `/admin/blog-category/delete/${id}`
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting blog category:", error);
    throw error;
  }
};